import React from 'react';
import { styled, StyledProps } from '@glitz/react';
import { Style, StyleOrStyleArray } from '@glitz/type';
import { StyledDecorator } from '@glitz/react/types/styled/decorator';
import { Close12x12 as Close } from 'Shared/Icons/Close';
import FacetViewModel from 'Shared/Facet/FacetViewModel.type';
import FacetValueViewModel from 'Shared/Facet/FacetValueViewModel.type';
import * as style from 'Shared/Style';

type PropType = {
  activeFacets: FacetViewModel[];
  onRemoveFacet?: Function;
  css?: StyledDecorator | StyleOrStyleArray<Style>;
  itemCss?: StyledDecorator | StyleOrStyleArray<Style>;
}

const ActiveFilterContainer = styled.div({
  width: '100%',
  flexBasis: '100%',
  display: 'flex',
  flexWrap: 'wrap',
  gap: '8px',
  margin: { bottom: '24px', top: '-12px'}
})

export const ActiveFilter = styled.div({
  display:'flex',
  borderRadius: '100px',
  textTransform: 'uppercase',
  padding: { y:'8px', x:'12px' },
  justifyContent: 'center',
  alignItems: 'center',
  font: { size:'12px', weight: 500 },
  cursor: 'pointer',
})

const RemoveIcon = styled(Close, {
  marginLeft: '6px'
})

export const getActiveFacets = (facets: FacetViewModel[]) => {
  return facets?.filter((facet) => {
    if (facet.type.toLowerCase() === 'range') {
      return facet.max !== facet.maxSelected || facet.min !== facet.minSelected
    }

    return facet.selectedCount > 0})
}

export default (props: PropType & StyledProps) => {
  const { onRemoveFacet = () => {}, activeFacets = [], compose, itemCss = {backgroundColor: style.colors.monochrome.extraLightGrey } } = props

  return <ActiveFilterContainer css={compose(props.css)}>
    {activeFacets.map((activeFacet: FacetViewModel) => {

      if (activeFacet.type.toLowerCase() === 'range') {
          return <ActiveFilter css={ itemCss } key={activeFacet.id} onClick={() => { onRemoveFacet(activeFacet) }}>
            <span>{activeFacet.minSelected} - {activeFacet.maxSelected}</span><RemoveIcon />
          </ActiveFilter>
      }

      return activeFacet.values.map((facetValue: FacetValueViewModel) => {
        if (facetValue.selected === false) {
          return undefined
        }
        
        return <ActiveFilter css={ itemCss } key={facetValue.id} onClick={() => { onRemoveFacet(activeFacet, facetValue) }}>
          <span>{facetValue.displayName}</span><RemoveIcon />
        </ActiveFilter>
      })
    })}
  </ActiveFilterContainer>
}

